import moment from "moment/moment";
export const DataEntryMixin = {
  props: {
    value: {
      // type: [ String, Number ],
      required: true,
    },
    field: {
      type: Object,
      required: true,
    },
  },
  computed: {
    // data-entry组件参数
    parameters({ $props }) {
      return $props.field.commonProperties
        ? JSON.parse($props.field.commonProperties).options
        : {};
    },
    changeValue: {
      get() {
        // 设置下拉框历史值回显
        // const { value } = this;
        // const _value = value ? value : null;
        // const sourceData = this.parameters.options || [];

        if (this.field.fieldFormType === "number") {
          if (
            !this.value &&
            this.value !== 0 &&
            (this.parameters.defaultValue || this.parameters.defaultValue === 0)
          ) {
            this.$emit("update:value", Number(this.parameters.defaultValue));
          }
          return this.value;
        } else if (this.field.fieldFormType === "date") {
          if (
            !this.value &&
            this.value !== null &&
            this.parameters.defaultValueOptions &&
            this.parameters.format !== "YYYY-MM"
          ) {
            if (this.parameters.defaultValueOptions === "today") {
              if (this.parameters.format === "YYYY-MM-DD HH:mm:ss") {
                this.$emit(
                  "update:value",
                  moment().format("YYYY-MM-DD HH:mm:ss")
                );
              }
              if (this.parameters.format === "YYYY-MM-DD") {
                this.$emit("update:value", moment().format("YYYY-MM-DD"));
              }
            }

            if (this.parameters.defaultValueOptions === "yesterday") {
              if (this.parameters.format === "YYYY-MM-DD HH:mm:ss") {
                this.$emit(
                  "update:value",
                  moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss")
                );
              }
              if (this.parameters.format === "YYYY-MM-DD") {
                this.$emit(
                  "update:value",
                  moment().subtract(1, "days").format("YYYY-MM-DD")
                );
              }
            }
          }
          return this.value || this.parameters.defaultValue || "";
        }
        // else if (this.field.fieldFormType === "select") {
        //   if (!this.value && this.parameters.defaultValue) {
        //     console.log("进入了select的默认值设置", this.value);
        //     this.$emit("update:value", this.parameters.defaultValue);
        //   }

        //   // 设置下拉框历史值回显
        //   const findItem = sourceData.find((item) => item.value === _value);
        //   return findItem && findItem.isEnable == 0
        //     ? findItem.label
        //     : this.value || this.parameters.defaultValue || "";

        //   // return this.value || this.parameters.defaultValue || "";
        // }
        else {
          if (!this.value && this.value !== 0 && this.parameters.defaultValue) {
            this.$emit("update:value", this.parameters.defaultValue);
          }

          //企微添加方式特殊处理
          if (
            this.value === 0 &&
            this.field.fieldCode === "enterprise_add_mode"
          ) {
            console.log("进入企微return", this.value);
            return this.value;
          }
          return this.value || this.parameters.defaultValue || "";
        }
      },
      set(val) {
        if (["input"].includes(this.field.fieldFormType)) {
          this.$emit("update:value", val.trim());
          this.$forceUpdate();
        } else if (
          ["select", "radio", "checkbox"].includes(this.field.fieldFormType)
        ) {
          this.$emit("update:value", val);
          console.log("下拉选择传出", val);
          this.$emit("onValidate");
        } else {
          this.$emit("update:value", val);
          this.$forceUpdate();
        }
      },
    },
  },
};
